import React, { PureComponent } from "react";
import styled from "styled-components";
import { dateFormat, dateFormatForMonth, scrollIntoViewIfNeeded } from "./utils";
import { Progress } from "./progress";
import { DATE_LIST_PADDING } from "./config";
import tinycolor from "tinycolor2";
import { getTransparentColor } from "../../colors/default";
// tslint:disable: variable-name
const DateListContainerStyle = styled.div `
  @keyframes bubble-in
  {
    0% {
      width: 4px;
      height: 4px;
      left: 6px;
      top: 6px;
    }
    10% {
      width: 6px;
      height: 6px;
      left: 5px;
      top: 5px;
    }
    75% {
      width: 20px;
      height: 20px;
      left: -2px;
      top: -2px;
    }
    90% {
      width: 18px;
      height: 18px;
      left: -1px;
      top: -1px;
    }
    100% {
      width: 16px;
      height: 16px;
      left: 0px;
      top: 0px;
    }
  }
  @keyframes bubble-out
  {
    0% {
      width: 16px;
      height: 16px;
      left: 0px;
      top: 0px;
    }
    20% {
      width: 14px;
      height: 14px;
      left: 1px;
      top: 1px;
    }
    100% {
      width: 4px;
      height: 4px;
      left: 6px;
      top: 6px;
    }
  }
  display: flex;
  height: 100%;
  /* 解决自动滚动后，第一项显示不全的问题 */
  .item:first-child{
    margin-left: 2em;
  }
`;
const DateListItem = styled.div `
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-start;
  align-items: center;
  white-space: nowrap;
  cursor: pointer;
  position: relative;
  .anchor{
    position: absolute;
    pointer-events: none;
    height: 1px;
    width: 110px;
    left: -46px;
  }
`;
const NodContent = styled.div `
  font-size: 14px;
  flex: 1 0 14px;
  line-height: 14px;
  margin: 4px;
`;
/** 初始节点单独样式 */
const FirstDotStyle = styled.div({});
/** 末尾节点单独样式 */
const LastDotStyle = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
/**
 * 一年内的时间轴
 *
 * @author 张卓诚
 * @export
 * @class DateList
 * @extends {PureComponent<ListProps, ListState>}
 * @implements {Color}
 */
export default class DateList extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            loadingHighlight: true,
        };
        /** 高亮样式 */
        this.activeColor = this.props.colorPalette.mainColor[1];
        /** 进度条颜色 */
        this.progressColor = getTransparentColor(this.props.colorPalette.mainColor[2], 4);
        /** 默认文字颜色 */
        this.defaultTextColor = this.props.colorPalette.mainColor[2];
        /** 样式 */
        // tslint:disable-next-line: naming-convention
        this.NodContainer = styled.div `
    color: ${p => p.active ? this.activeColor : this.defaultTextColor};
    flex: 0 0 16px;
    width: 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    cursor: pointer;
    white-space: nowrap;
    &.nod-content {
      .normal {
        display: ${p => p.active ? "none" : "inline"};
      }
      .hover {
        display: none;
        color: ${this.props.colorPalette.mainColor[1]};
      }
      .active {
        display: ${p => p.active ? "inline" : "none"};
        color: ${this.props.colorPalette.mainColor[1]};
      }
      &:hover {
        .normal {
          display: none;
          color: ${this.props.colorPalette.mainColor[1]};
        }
        .hover {
          display: ${p => p.active ? "none" : "inline"};
          color: ${this.props.colorPalette.mainColor[1]};
        }
        .active {
          display: ${p => p.active ? "inline" : "none"};
          color: ${this.props.colorPalette.mainColor[1]};
        }
        .circle-container{
          .circle{
            border: 1px solid ${this.props.colorPalette.mainColor[1]};
          }
          .dot{
            background: ${this.props.colorPalette.mainColor[1]};
          }
        }
      }
      .circle-container{
        width: 16px;
        height: 16px;
        border-radius: 50%;
        flex: 0 0 16px;
        position: relative;
        .circle{
          position: absolute;
          width: ${p => p.active ? 16 : 4}px;
          height: ${p => p.active ? 16 : 4}px;
          left: ${p => p.active ? 0 : 6}px;
          top: ${p => p.active ? 0 : 6}px;
          animation: ${p => p.active ? "bubble-in" : "bubble-out"} 0.3s;
          border-radius: 50%;
          border: 1px solid ${p => p.active ?
            this.props.colorPalette.mainColor[2] : tinycolor(this.props.colorPalette.mainColor[2]).setAlpha(0).toString()};
          background-color: ${getTransparentColor(this.props.colorPalette.mainColor[1], 3)};
        }
        .dot{
          position: absolute;
          left: 6px;
          top: 6px;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: ${p => p.active ?
            this.props.colorPalette.mainColor[2] : getTransparentColor(this.props.colorPalette.mainColor[2], 4)};
        }
      }

    }
  `;
        /**
         * 点击日期，记录日期渲染所在索引
         */
        this.toggleActive = (item) => {
            /** 暂停播放 */
            this.props.pause();
            this.props.changeDateByKey(item.key);
        };
    }
    componentDidMount() {
        this.scrollIntoCurrentPlayed(this.props);
    }
    componentDidUpdate() {
        this.scrollIntoCurrentPlayed(this.props);
    }
    /** 是播放中 */
    isPlaying(elapse) {
        return elapse.playState === "playing";
    }
    render() {
        const { loadingHighlight } = this.state;
        const { playStates, dateGrouping, yearIndex, } = this.props;
        const dateList = dateGrouping[yearIndex].children;
        const playStateList = playStates[yearIndex].children;
        const dayFormated = dateFormat(dateList);
        const monthFormated = dateFormatForMonth(dateList);
        const dateListLength = dateList.length - 1 || 0;
        return (React.createElement(DateListContainerStyle, null, 
        // tslint:disable: jsx-no-multiline-js
        // tslint:disable-next-line: cyclomatic-complexity
        dayFormated && dayFormated.map((item, index) => (React.createElement(DateListItem, { key: item.key, className: `key-${item && item.key} item`, 
            // tslint:disable-next-line: jsx-no-lambda
            onClick: () => { this.toggleActive(item); } },
            React.createElement(FirstDotStyle, { style: { paddingRight: dateListLength !== index ? 0 : DATE_LIST_PADDING } },
                React.createElement(this.NodContainer, { className: "nod-content", active: this.isPlaying(playStateList[index]) },
                    React.createElement(NodContent, { className: "month" },
                        React.createElement("span", { className: "normal" }, monthFormated[index].normal),
                        React.createElement("span", { className: "hover" }, monthFormated[index].hover),
                        React.createElement("span", { className: "active" }, monthFormated[index].active)),
                    React.createElement("div", { className: "circle-container" },
                        React.createElement("div", { className: "circle" }),
                        React.createElement("div", { className: "dot" })),
                    React.createElement(NodContent, { className: "day" },
                        React.createElement("span", { className: "normal" }, item.normal),
                        React.createElement("span", { className: "hover" }, item.hover),
                        React.createElement("span", { className: "active" }, item.active)))),
            React.createElement(LastDotStyle, { style: { display: dateListLength !== index ? "inherit" : "none" } },
                React.createElement(Progress, { clearHighlight: loadingHighlight, yearIndex: yearIndex, dayIndex: index, colorPalette: this.props.colorPalette, style: { backgroundColor: this.progressColor } })),
            React.createElement("div", { className: "anchor" }))))));
    }
    /**
     * 滚动至播放节点
     */
    scrollIntoCurrentPlayed(props) {
        // tslint:disable-next-line: early-exit
        if (props.play) {
            if (props.dayIndex === 0) {
                scrollIntoViewIfNeeded(`.key-${props.playStates[props.yearIndex].children[props.dayIndex].key} .anchor`);
                window.setTimeout(() => scrollIntoViewIfNeeded(`.key-${props.playStates[props.yearIndex].children[props.dayIndex + 1].key} .anchor`), props.interval / 2);
                // tslint:disable-next-line: no-empty
            }
            else if (props.dayIndex === props.playStates[props.yearIndex].children.length - 1) {
            }
            else {
                window.setTimeout(() => scrollIntoViewIfNeeded(`.key-${props.playStates[props.yearIndex].children[props.dayIndex + 1].key} .anchor`), props.interval / 2);
            }
        }
        else {
            window.setTimeout(() => scrollIntoViewIfNeeded(`.key-${props.playStates[props.yearIndex].children[props.dayIndex].key} .anchor`), 500);
        }
    }
}
//# sourceMappingURL=date-list.js.map